export const completionPercentage = (
  numberOfCompletedValues,
  totalRequiredValues,
) => {
  return Math.round((numberOfCompletedValues / totalRequiredValues) * 100);
};
